import { FORD } from '@rsos/constants/orgsWithQueueText';
import {
  isCallerIDFromOrg,
  type EmergencyCallsMap,
} from '@rsos/utils/isCallerIDFromOrg';

const isFordLocationField = (value: unknown): boolean =>
  typeof value === 'string' && value.toLowerCase() === 'ford';

/**
 * True for Ford VIN-keyed crash/location rows.
 * Prefer location.application / location.source (available on POST_LOCATION)
 * so phone-centric UI is suppressed before ADR arrives; fall back to
 * additionalData.ford for ADR-only edge cases.
 */
export const isFordCallerID = (
  emergencyCalls: EmergencyCallsMap | null | undefined,
  callerID: string | null | undefined,
): boolean => {
  if (!emergencyCalls || !callerID) return false;
  if (isCallerIDFromOrg(FORD, emergencyCalls, callerID)) return true;

  const locations = emergencyCalls[callerID]?.core?.locations ?? [];
  return locations.some(
    loc =>
      isFordLocationField(loc?.application) || isFordLocationField(loc?.source),
  );
};

export default isFordCallerID;
